import { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, TableContainer } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { ChurnReasonRow, DestroyChurnReason } from '../'

const ChurnReasonsTable = ({ churnReasons, refresh }) => {
  const [selectedChurnReason, setSelectedChurnReason] = useState({})
  const [open, setOpen] = useState(false)

  return (
    <Box width="100%">
      <TableContainer>
        <Table emptyMessage="Nenhum motivo de churn encontrado">
          <TableHead>
            <TableRow>
              <TableCell width="5%">ID</TableCell>
              <TableCell width="40%" align="left" wrap>
                Nome
              </TableCell>
              <TableCell width="40%" align="left">
                Descrição
              </TableCell>
              <TableCell width="40%" align="left">
                Padrão
              </TableCell>
              <TableCell width="5%" align="center">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {churnReasons?.map((churnReason) => (
              <ChurnReasonRow
                churnReason={churnReason}
                key={churnReason.id}
                setSelectedChurnReason={setSelectedChurnReason}
                setOpen={setOpen}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedChurnReason?.id && (
        <DestroyChurnReason
          churnReason={selectedChurnReason}
          refresh={refresh}
          open={open}
          setOpen={setOpen}
        />
      )}
    </Box>
  )
}

ChurnReasonsTable.propTypes = {
  churnReasons: PropTypes.arrayOf(PropTypes.object),
  refresh: PropTypes.func,
}

export default ChurnReasonsTable
